import React, { useEffect, useRef } from "react";
import { createAbsoluteUrl } from "utils/constants";

import { Button } from "app/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "app/components/ui/dialog";

interface Props {
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
  onCloseComplete?: () => void;
  apiErrorMessage?: string;
}

export const ErrorDialog = ({
  showDialog,
  setShowDialog,
  onCloseComplete,
  apiErrorMessage,
}: Props) => {
  const prevOpen = useRef(showDialog);
  useEffect(() => {
    if (prevOpen.current && !showDialog) {
      onCloseComplete?.();
    }
    prevOpen.current = showDialog;
  }, [showDialog, onCloseComplete]);

  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent
        className="top-1/2 gap-0 bg-white w-[95%] sm:max-w-[29.5rem] p-4 sm:p-5 lg:p-6"
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        {/* Close button */}
        <Button
          type="button"
          variant="ghost"
          className="absolute top-4 right-4 z-10 p-0 hover:bg-transparent hover:brightness-50 rounded-full focus:ring-2 focus:ring-[#1D1D1B]"
          onClick={() => setShowDialog(false)}
          aria-label="Close dialog"
        >
          <img
            src="/assets/close-circle.webp"
            className="size-5 md:size-6"
            alt="Close"
          />
        </Button>
        <DialogHeader className="relative flex justify-center items-center p-0 mb-4 bg-transparent md:mb-5">
          <div className="shrink-0 flex justify-center items-center bg-[#FFE9DF] size-[3.25rem] sm:size-14 md:size-[3.75rem] lg:size-[3.875rem] rounded-full mb-1 sm:mb-1.5 lg:mb-2">
            <div className="size-6 sm:size-[1.625rem] md:size-7 lg:size-[1.875rem]">
              <img
                src="/assets/error-triangle.svg"
                alt="Error"
                className="size-full"
              />
            </div>
          </div>
          <DialogTitle className="capitalize pb-1 text-xl font-bold leading-6 text-black lg:text-2xl md:leading-7 font-mobile">
            we are sorry!
          </DialogTitle>
          <DialogDescription className="text-center text-[0.825rem] sm:text-sm font-medium leading-4 sm:leading-5 lg:leading-[1.3125rem] text-[#3C3C3C]">
            {apiErrorMessage ||
              "We currently don't offer our service at your address. For assistance, please contact support."}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 sm:space-y-3.5 lg:space-y-4">
          <Button
            type="button"
            variant="primary"
            className="h-10 sm:h-12 md:h-[3.25rem] lg:h-[3.375rem] md:rounded-2xl font-semibold"
            onClick={() => {
              setShowDialog(false);
              // navigate("/");
              window.location.href = createAbsoluteUrl();
            }}
          >
            Go Home
          </Button>
          <Button
            type="button"
            variant="outline"
            className="h-10 sm:h-12 md:h-[3.25rem] lg:h-[3.375rem] md:rounded-2xl font-semibold"
            onClick={() => {
              setShowDialog(false);
              // navigate("/support-tickets");
              window.location.href = createAbsoluteUrl("/support-tickets");
            }}
          >
            Contact Support
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
